import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { SECUREPAY_SHARED_CONFIG } from '../config/securepay-shared-config';
import { ApiResponse } from '../models/securepay';
import { GoLiveResult } from './merchant-environment-mode';

@Injectable({ providedIn: 'root' })
export class MerchantEnvironmentService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(SECUREPAY_SHARED_CONFIG);

  goLive() {
    return this.http.post<ApiResponse<GoLiveResult | null>>(
      `${this.config.apiBaseUrl}/api/OpsGoLive/go-live`,
      {},
    );
  }

  activateSandbox() {
    return this.http.post<ApiResponse<unknown>>(
      `${this.config.apiBaseUrl}/api/Sandbox/activate`,
      {},
    );
  }
}
